import ExpandableDesktop from './ExpandableDesktop';
import { withI18n } from 'react-i18next';

export default withI18n()(ExpandableDesktop);
